/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useQuery } from '@tanstack/react-query'
import { getMetricsTop } from '../../../../../services/Metrics/Metrics.service'
import { formatISO, roundToNearestMinutes, startOfDay, subDays } from 'date-fns'
import { isProviderAPos } from '../../../../../services/Provider/Provider.service'
import { getCancellationSource } from '../../../../../services/http-client'
import useUser from '../../../../Shared/UserProvider/useUser'
import { Card, CardExtra } from '../../../Shared/Card'
import { Link } from 'react-router-dom-v5-compat'
import { Icon } from 'semantic-ui-react'
import React from 'react'
import { TopProductsCardContent } from './TopProductsCardContent'
import { NoTopProductsCardContent } from './NoTopProductsCardContent'
import { LoadingPlaceholderCardContent } from '../../../Shared/LoadingPlaceholderCardContent'
import { useDeviceMediaQuery } from '../../../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'


const TopProductsCard = () => {
    const from = formatISO(startOfDay(subDays(new Date(), 7)))
    const to = formatISO(roundToNearestMinutes(new Date(), {nearestTo: 10, roundingMethod: 'floor'}))
    const {user} = useUser()
    const { isMobile } = useDeviceMediaQuery()

    const {data, isLoading} = useQuery({
        queryKey: ['top-products', from, to],
        queryFn: async () => await getMetricsTop({
            dateRange: {
                startDate: from,
                endDate: to,
            },
            merchantId: isProviderAPos(user.provider) ? user.provider.object.id : undefined,
            brandIds: [],
            platformIds: [],
        }, getCancellationSource()),
    })

    return (
      <Card
        css={css`
            border-top: ${isLoading ? '0' : '2px'} solid grey;
            .card-content {
                width: ${isMobile ? '340px' : '360px'};
                height: 416px;
            }
        `}
      >
          {isLoading ? (
            <LoadingPlaceholderCardContent/>
          ) : (
            (data && data.top.length > 0 && data.topCA.length > 0) ?
              <TopProductsCardContent data={data} /> :
              <NoTopProductsCardContent />
          )}
          <CardExtra>
              <Link
                to={{
                    pathname: '/analytics',
                    search: new URLSearchParams({
                        from,
                        to,
                    }).toString(),
                }}>
                  Top ventes
                  <Icon name="arrow right"/>
              </Link>
          </CardExtra>
      </Card>
    )
}

export { TopProductsCard }
